import customHeaders, { getSpace } from '../../common/headers';
import { useEffect, useRef, useState } from 'react';
import { useDataTable } from '../../common/hooks';
import { ButtonBasic, TableBox } from '@lk-gtcom/ecomlab-components';
import { ModalCreateChatBot } from '../../components/Modal/ModalCreateChatBot/ModalCreateChatBot';
import './ChatBot.scss';
import useGeneralStore from '../../store/general';
import { Andrey3Https } from '../../fetchUrls';
import ChatWidget from './ChatWidget';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import ModalWarning from '../../components/Modal/ModalWarning/ModalWarning';
import { useResponseHandler } from '../../common/auth';

const ChatBot = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) }
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const [isModal, setIsModal] = useState(false);
  const [isModalDelete, setIsModalDelete] = useState(false);

  const [botId, setBotId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const [isCreateChat, setIsCreateChat] = useState(false);
  const [chatName, setChatName] = useState('');
  const [id, setId] = useState(null)

  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading } = setTableFuncs;
  const chatScript = `<script
  src="http://localhost:3001/widget.js"
  async
  data-bot-id="${botId}"
  data-session-id="${'3d7ced5e-d29c-4621-8a47-cd8a3cf81b87'}"></script>
  `;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(chatScript);
  };

  const handleEdit = (Идентификатор) => {
    setBotId(Идентификатор[0]);
    setIsModal(true);
    setIsEdit(true);
  };

  const handleKillChat = () => {
    setIsCreateChat(false);
    setBotId(null);
  };

  const contextMenuArr = [
    {
      label: 'Создать чат',
      onClick: ({ Идентификатор, 'Имя бота': botName }) => {
        if (!isCreateChat) {
          setBotId(Идентификатор[0]);
          setIsCreateChat(true);
          setChatName(botName);
        } else {
          handleKillChat();
          setTimeout(() => {
            setBotId(Идентификатор[0]);
            setIsCreateChat(true);
            setChatName(botName);
          }, 500);
        }
      },
    },
    {
      label: 'Скопировать',
      onClick: ({ Идентификатор }) => {
        copyToClipboard();
      },
    },
    {
      label: 'Изменить',
      onClick: ({ Идентификатор, 'Имя бота': botName }) => {
        handleEdit(Идентификатор);
        setChatName(botName);
      },
    },
    {
      label: 'Удалить',
      onClick: ({ Идентификатор }) => {
        setId(Идентификатор[0])
        setIsModalDelete(true)
      },
    },
  ];

  const onAction = ({ Идентификатор, 'Имя бота': botName }) => {
    if (!isCreateChat) {
      setBotId(Идентификатор);
      setIsCreateChat(true);
      setChatName(botName);
    } else {
      handleKillChat();
      setTimeout(() => {
        setBotId(Идентификатор);
        setIsCreateChat(true);
        setChatName(botName);
      }, 500);
    }
  }

  //таблица ботов
  const fetchBotList = (params) => {
    setLoading(true)
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    let url = `${Andrey3Https}/bot/bot-list${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`;

    const body = JSON.stringify({
      limit: paginatorRef.current.limit,
      page: paginatorRef.current.page,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => setLoading(false))
  };

  // удалить чат бот
  const fetchDeleteBot = (bot_id) => {
    let url = `${Andrey3Https}/bot/${bot_id}/delete`

    fetch(url, { method: 'DELETE', headers })
      .then(handleTableResponse)
      .then((json) => fetchBotList())
      .catch(handleRequestError);
  };

  const resetTable = () => {
    if (paginatorRef.current) {
      paginatorRef.current.reset();
    }
    fetchBotList();
  };

  useEffect(() => {
    if (!isModal) {
      fetchBotList();
    }
  }, [isModal]);

  return (
    <>
      {isModal &&
        <ModalCreateChatBot
          setIsModal={setIsModal}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          botId={botId}
          setBotId={setBotId}
          chatName={chatName}
          setChatName={setChatName}
        />
      }

      {isModalDelete && <ModalWarning
        headerText='Подтвердите удаление'
        messageText={'Вы точно хотите удалить чат-бот?'}
        approveButtonText='Удалить'
        cancelButtonText='Отмена'
        colorBtn='red'
        onApproveClick={() => {
          fetchDeleteBot(id)
          setId(null)
          setIsModalDelete(false)
        }}
        onCancelClick={() => setIsModalDelete(false)}
      />}

      {isCreateChat &&
        <ChatWidget
          botId={botId}
          chatName={chatName}
          handleKillChat={handleKillChat}
        />
      }

      <div className="chat-bot">
        <TitlePage
          title='Чат-боты'
        />

        <ButtonBasic
          green
          onClick={() => setIsModal(true)}
          text={'+ Создать бота'}
        />

        <TableBox
          {...tableProps}
          ref={paginatorRef}
          paginator={true}
          fetchCallback={fetchBotList}
          contextMenuArr={contextMenuArr}
          onAction={onAction}
          child={
            <ButtonBasic
              whiteGreen
              text={'Обновить таблицу'}
              size="32px"
              width='auto'
              onClick={resetTable}
            />
          }
        />
      </div>
    </>
  );
};

export { ChatBot };
